import numeral from "numeral";
import { useMemo } from "react";
import { useInsuranceStore } from "../../../_store/insuranceStore";
import { ImageMain } from "../../../components/img/Img.Main";
import { defaultValue } from "../../../functions/main";
import { cn } from "../../../utils/useFunctions";
import ViewTableFamily from "../../insuarance_plan/component/VITableFamily.Main";
import {
  PdfCard,
  PdfCardWhite,
  PdfFamilyHeaderItemCard
} from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderText
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_NORMAL_11,
  STYLE_PDF_TEXT_NORMAL_BLUE_10
} from "../styles/pdf.style";

function PdfPageFamilyTwo({page}) {
  const insuranceData = useInsuranceStore((state) => state.insuranceData);

  const status = useMemo(() => {
    if (insuranceData.sum_insurance_more === 0) {
      return "normal";
    } else if (insuranceData.sum_insurance_more < 0) {
      return "toomuch";
    }
    return "more";
  }, [insuranceData]);

  const checkicon = () => {
    if (status === "more") {
      return "../images/bad_face.png";
    } else if (status === "normal") {
      return "../images/verygoodface.png";
    } else if (status === "toomuch") {
      return "../images/taxicon3.png";
    }
  };

  const checkstatus = (status) => {
    if (status === "more") {
      return "ต้องซื้อเพิ่มอีก";
    } else if (status === "normal") {
      return "ยอดเยี่ยม";
    } else if (status === "toomuch") {
      return "ทุนประกันเกินจากที่แนะนำ";
    }
  };

  const checkText = (status) => {
    if (status === "more") {
      return (
        <div className=" text-maincyan font-semibold text-[17px] text-center">
          {numeral(insuranceData.sum_insurance_more)?.format("0,0")} บาท
        </div>
      );
    } else if (status === "normal") {
      return (
        <div className=" text-mainblue font-semibold text-[17px] text-center">
          คุณมีทุนประกันที่วางแผนมาแล้วอย่างพอดี
        </div>
      );
    } else if (status === "toomuch") {
      return (
        <div className=" text-mainblue font-semibold text-[17px] text-center">
          คุณรักครอบครัวมาก มีการคุ้มครองมาดีแล้ว
        </div>
      );
    }
  };

  const familyItems = useMemo(() => {
    const newFamilyItems = [
      {
        label: "ทุนประกันที่ควรมีเพื่อคุ้มครองครอบครัว 5 ปี",
        value: numeral(
          (defaultValue(insuranceData.sum_income) -
            defaultValue(insuranceData.sum_personal_expenses)) *
            5
        ).format("0,0"),
      },
      {
        label: `ทุนประกันที่ควรมีเพื่อคุ้มครองครอบครัว ${insuranceData?.family_year_survive}`,
        value: numeral(insuranceData?.sum_family_remain)?.format("0,0"),
      },
      insuranceData?.asset_is_debt === "Y" && {
        label: "หนี้สินทั้งหมดของคุณ",
        value: numeral(insuranceData?.sum_family_debt)?.format("0,0"),
      },
      {
        label: "ทุนประกันสุทธิ",
        value: numeral(insuranceData?.sum_insurance_net)?.format("0,0"),
      },
      {
        label: "ทุนประกันที่คุณมี ณ ปัจจุบัน",
        value: numeral(insuranceData?.sum_insurance_current)?.format("0,0"),
      },
      {
        label: "มูลค่าทรัพย์สิน",
        value: numeral(insuranceData?.sum_asset_current)?.format("0,0"),
      },
    ];
    return newFamilyItems;
  }, []);

  

  const items = useMemo(() => {
    const newItems = [
      {
        label:
          "ประกันชั่วระยะเวลา เบี้ยประกันสูง ทุนประกันสูงไม่เน้นเงินคืนใช้คุ้มครองชีวิตวิตามระยะเวลาเป้าหมาย ที่เรากำหนด เช่น 5 ปี, 10 ปี, 20 ปี ",
      },
      {
        label:
          "ประกันแบบตลอดชีพชำระเบี้ยเพื่อให้มีความคุ้มครองตลอดตลอดระยะเวลาที่เรามีชีวิต",
      },
      {
        label: "ประกันแบบสะสมทรัพย์ จุดประสงค์เพื่อให้มีเงินก้อน",
      },
      {
        label:
          "ตามเป้าหมายระยะเวลาที่เรากำหนด โดยมีความคุ้มครองชีวิตประกันแบบ UNIT LINK เป็นประกันที่ให้ความคุ้มครองชีวิตวิพร้อมกับโอกาสในการรับผลตอบแทนจากกองทุนรวม",
      },
    ];
    return newItems;
  }, []);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfCard
        className={"flex flex-col space-y-3"}
        title="ผลลัพธ์วางแผนทุนประกันชีวิต"
      >
       <PdfCardWhite className={"h-fit"}>
          <PdfFamilyHeaderItemCard title={"รายการ"} />
          <PdfLine />
          {insuranceData?.asset_is_debt === "Y" && (
            <div className="flex flex-col mx-4">
              <div className="flex items-center space-x-2 mb-1">
                <div>
                  <img src="/images/money_bag.svg" />
                </div>
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
                  ทุนประกันเพื่อการศึกษาบุตร
                </div>
              </div>
              <ViewTableFamily
                className={cn(STYLE_PDF_TEXT_NORMAL_BLUE_10, "p-1")}
              />
            </div>
          )}

          <div className=" mx-auto flex justify-center items-center space-x-2">
            <div className="flex justify-center items-center gap-2 font-medium">
              <ImageMain
                src={checkicon(status)}
                alt="insu_plan_3"
                className=" w-6 h-6"
              />
              <div className="text-[15px]">{checkstatus(status)}</div>
            </div>
            {checkText(status)}
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfHeaderText
        title="แผนทุนประกันคุ้มครองครอบครัว"
        icon="/images/family.svg"
      />
      
      {/* ทุนประกัน */}
      <PdfCard className={"flex flex-col space-y-3"}>
        <div className="flex items-center space-x-2">
          <div>
            <img src="/images/lamp_yellow.svg" />
          </div>
          <div className={cn(STYLE_PDF_TEXT_MEDIUM_13)}>
            แนะนำแบบประกันชีวิต
          </div>
        </div>
        <PdfCardWhite>
          <div className="flex flex-col mx-3 space-y-1 py-1">
            {items.map((item, index) => {
              return (
                <div key={index} className={cn(STYLE_PDF_TEXT_NORMAL_11)}>
                  {index + 1}. {item.label}
                </div>
              );
            })}
          </div>
        </PdfCardWhite>
      </PdfCard>
      <div
        className={cn(
          "mt-10 px-10 flex justify-center text-center",
          STYLE_PDF_TEXT_NORMAL_11
        )}
      >
        ติดต่อนักวางแผนการเงิน CFP® ตัวแทนประกันชีวิตและนักวางแผนการเงิน
        ที่ท่านไว้วางใจเป็นเพื่อนคู่คิดตลอดเส้นทางชีวิต
      </div>
      <PdfFooter page={page}/>
    </div>
  );
}

export default PdfPageFamilyTwo;
